import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MatButtonModule} from '@angular/material';

import { Angulartics2Module } from 'angulartics2';
import { Angulartics2Piwik } from 'angulartics2/piwik';

import { LOCALE_ID } from '@angular/core';

import { HttpModule } from '@angular/http';

import { MarkdownModule } from 'angular2-markdown';
// bootstrap
import {NgbModule, NgbModal} from '@ng-bootstrap/ng-bootstrap';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { WpService } from './service/wp.service'
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { PageComponent }  from './page/page.component';
import { BlogComponent } from './blog/blog.component';
import { PostComponent } from './post/post.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { CalenderComponent } from './calender/calender.component';
import { KursComponent } from './kurs/kurs.component';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { BilderComponent } from './bilder/bilder.component';
registerLocaleData(localeDe);

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    pathMatch: 'full'
  },
  {
    path: 'blog',
    component: BlogComponent,
  },
  {
    path: 'kalender',
    component: CalenderComponent
  },
  {
    path: 'bilder',
    component: BilderComponent
  },
  {
    path: 'kurs/:id',
    component: KursComponent
  },
  {
    path: ':page',
    component: PageComponent
  },
  {
    path: 'blog/:name',
    component: PostComponent,
  },
  {
    path: '*',
    component: MainComponent
  }
];

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    MenuComponent,
    FooterComponent,
    PageComponent,
    BlogComponent,
    PostComponent,
    NewsletterComponent,
    CalenderComponent,
    KursComponent,
    BilderComponent,
  ],
  imports: [
    Angulartics2Module.forRoot([Angulartics2Piwik]),
    RouterModule.forRoot(routes),
    MarkdownModule.forRoot(),
    NgbModule.forRoot(),
    BrowserModule,
    HttpModule,
    BrowserAnimationsModule,
    MatButtonModule,
  ],
  exports: [
    MatButtonModule
  ],
  providers: [
    NgbModal,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    HttpModule,
    WpService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    NewsletterComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/app.module.ts